import React from 'react'
import { useSelector } from 'react-redux'

import './EHPResult.scss'

const EHPResult = props => {
    // console.log('EHPResult', props)
    const buildings = useSelector(state => state.buildings)
    let formula

    if (props.basic) {
        formula = props.HP * (1140 + (props.DEF * 3.5)) / 1000
    } else {
        const arenaDEFBuilding = buildings.find(el => el.id === 'guardstone') // guardstone
        const arenaDEF = arenaDEFBuilding.options.find(el => el.value === arenaDEFBuilding.value).def
        const arenaHPBuilding = buildings.find(el => el.id === 'crystal_altar') // crystal_altar
        const arenaHP = arenaHPBuilding.options.find(el => el.value === arenaHPBuilding.value).hp
        const guildLevel = buildings.find(el => el.id === 'guild_level')
        const { hp: guildHP, def: guildDEF } = guildLevel.options.find(el => el.value === guildLevel.value)

        const totalBuildingDEF = ((100 + arenaDEF + guildDEF) / 100)
        const totalBuildingHP = ((100 + arenaHP + guildHP) / 100)
        const newDEF = (props.baseDEF * totalBuildingDEF) + props.runesDEF
        const newHP = (props.baseHP * totalBuildingHP) + props.runesHP
        formula = newHP * (1140 + (newDEF * 3.5)) / 1000
    }

    return <div className="EHPResult">
        EHP: {parseInt(formula)}
    </div>
}

export default EHPResult